__turbopack_context__.v({
  "buttonWrapper": "StepFormHeader-module-scss-module___78CWq__buttonWrapper",
  "header": "StepFormHeader-module-scss-module___78CWq__header",
  "root": "StepFormHeader-module-scss-module___78CWq__root",
  "subtitle": "StepFormHeader-module-scss-module___78CWq__subtitle",
  "suptitle": "StepFormHeader-module-scss-module___78CWq__suptitle",
  "title": "StepFormHeader-module-scss-module___78CWq__title",
});
